import { graphql, useStaticQuery } from 'gatsby'

export function GetDataEn() {
    return useStaticQuery(graphql`
        {
            text: datoCmsRenshinPageOther(title: { eq: "Cookie" }, locale: { eq: "en" }) {
                value
            }
            
            buttonAccept: datoCmsRenshinPageOther(title: { eq: "Cookie: Button accept" }, locale: { eq: "en" }) {
                value
            }
            
            buttonClose: datoCmsRenshinPageOther(title: { eq: "Cookie: Button close" }, locale: { eq: "en" }) {
                value
            }
        }
    `)
}